import { ForgotPasswordForm } from "@/components/forms/forgot-password-form";
import AuthLayout from "@/layouts/auth_layout";
import { useTranslation } from "react-i18next";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout
      headingInContent
      title={t("auth.forgot_title")}
      description={t("auth.forgot_description")}
    >
      <ForgotPasswordForm />
    </AuthLayout>
  );
}
